<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [detailsLink]="workshop.courseLink"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<p-dialog
  header="دریافت فایل‌های کارگاه"
  [(visible)]="showContentsDialog"
  [modal]="true"
  [rtl]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '500px' }"
>
  <div *ngIf="selectedContents?.length">
    <ul class="list-unstyled mb-0">
      <li *ngFor="let contentItem of selectedContents" class="content-item">
        <ng-icon name="lucidePaperclip" class="me-2 text-success"></ng-icon>
        <a
          href="#"
          (click)="downloadContent(contentItem); $event.preventDefault()"
          class="text-success"
        >
          {{ contentItem.file_name }}
        </a>
      </li>
    </ul>
  </div>
</p-dialog>
